import { logger } from '@fe/core';
import { setSystemHubNotification } from '../app/state/slices/global-slice';
import { setSetting } from '../app/state/slices/settings-slice';
import { store } from '../app/state/store';
import { SystemHubImportanceLevel } from '../types/systemhub-notification';
import { SystemHubService } from './axios/axios-api-v2-generated';

export async function downloadNotification() {
    try {
        const state = store.getState();
        const lastUpdateTimeString = state.settings.lastSystemHubUpdate;

        const response = await SystemHubService.getStatusAsync(
            { lastUpdate: lastUpdateTimeString ?? undefined },
            { withAuthorization: true }
        );
        if (response) {
            if (lastUpdateTimeString != response.lastUpdate) {
                store.dispatch(setSetting('lastSystemHubUpdate', response.lastUpdate ?? null));
                store.dispatch(
                    setSystemHubNotification({
                        notification: {
                            importance: response.importanceLevel ?? SystemHubImportanceLevel.none,
                            showPopup: response.showPopup ?? false,
                            text: response.popupText ?? null
                        }
                    })
                );
            }
        }
    } catch (err) {
        logger.trackException(err);
    }
}
